import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { CommonComponentsModule } from "components/common/common-components.module";
import { ComponentsModule } from "components/components.module";
import { IonicPageModule } from "ionic-angular";
import { CompanyPageModule } from "../company.module";
import { ClearingHouseView } from "./clearinghouse-view";

@NgModule({
  declarations: [ClearingHouseView],
  imports: [
    CommonComponentsModule,
    IonicPageModule.forChild(ClearingHouseView),
    TranslateModule,
    ComponentsModule,
    CompanyPageModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ClearingHousePageModule {
  static getClearingHouseViewComponent() {
    return ClearingHouseView;
  }
}



// WEBPACK FOOTER //
// ./src/pages/company/clearinghouse-view/clearinghouse-view.module.ts